// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"3c241587","256":"1e471ff9","278":"70f94acf","312":"001ae62a","384":"ce554a3d","412":"1e25d0ab","616":"03e4f9e6","620":"c2bf801a","628":"49815ceb","660":"21bbf1ca","676":"5ce5010d","708":"ab298dc7","808":"f721a338","848":"91f5cb31","856":"3dcf223f","952":"90a9b90b"}[chunkId] + ".chunk.js";
};